"use strict";

exports.__esModule = true;
exports.checkboxGroupTheme = exports.checkboxTheme = void 0;

var _themes = require("../themes");

var _Choice = require("../Choice");

// $FlowFixMe - strict theme keys incompatible with mapComponentThemes
var checkboxTheme = function checkboxTheme(baseTheme) {
  return (0, _themes.mapComponentThemes)({
    name: 'Choice',
    theme: (0, _Choice.choiceTheme)(baseTheme)
  }, {
    name: 'Checkbox',
    theme: {}
  }, baseTheme);
}; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes


exports.checkboxTheme = checkboxTheme;

var checkboxGroupTheme = function checkboxGroupTheme(baseTheme) {
  return (0, _themes.mapComponentThemes)({
    name: 'ChoiceGroup',
    theme: (0, _Choice.choiceGroupTheme)(baseTheme)
  }, {
    name: 'CheckboxGroup',
    theme: {}
  }, baseTheme);
};

exports.checkboxGroupTheme = checkboxGroupTheme;